import axios from 'axios';

const API_URL = 'https://seller.udyamwell.in/api'; // Replace with your actual API URL

export const loginUser = async (data: any) => {
  const response = await axios.post(`${API_URL}/v1/login`, data);
  return response.data;
};

export const signUpUser = async (data: any) => {
  const response = await axios.post(`${API_URL}/v1/signIn`, data);
  return response.data;
};


export const forgotPasswordUser = async (data: any) => {
  const response = await axios.post(`${API_URL}/v1/forgot-password`, data);
  return response;
};

export const forgotPasswordverifyOtp = async (data: any) => {
  const response = await axios.post(`${API_URL}/v1/verify-forgot-otp`, data);
  return response;
};


export const changePassword = async (data: any) => {
  const response = await axios.post(`${API_URL}/v1/change-password`, data);
  return response;
};


export const verifyOtp = async (data: any) => {
  const response = await axios.post(`${API_URL}/v1/verify-otp`, data);
  return response.data;
};